define('LNRS/Components/Containers/Stripes/CustomStripe',["jquery"], function ($) {

    function CustomStripe(scope, isInEditing, small, medium, large, smallBorder, mediumBorder) {
        if (isInEditing) {
            return;
        }

        if (small.length > 0) {
            var stripe = $(scope).find('.score-stripe');

            //if stripe is mantle and score hero image is shown image should not be loaded
            if (stripe.hasClass('mantle-white-box-right') || stripe.hasClass('mantle-white-box-left') || stripe.hasClass('mantle-no-box-left') || stripe.hasClass('mantle-no-box-right')) {
                var heroImage = stripe.find('div.score-hero-image');
                if (heroImage) {
                    if (heroImage.height() > 0) {
                        return;
                    }
                }

                //in case that section hero do not have image but it is infront of stripe component
                var scoreSectionHero = stripe.find('div.score-section-hero');
                if (scoreSectionHero && $(scoreSectionHero).offset()) {
                    var heroImageTop = $(scoreSectionHero).offset().top;
                    var stripeTop = $(stripe).offset().top;
                    if (stripeTop >= heroImageTop) {
                        return;
                    }
                }
            }

            if (isVisible(stripe) && !isImageLoaded(stripe)) {
                loadImage(stripe, small, medium, large, smallBorder, mediumBorder);
            } else {

                var scrollHandler = function () {
                    if (isVisible(stripe) && !isImageLoaded(stripe)) {
                        loadImage(stripe, small, medium, large, smallBorder, mediumBorder);
                        $(window).off("scroll", scrollHandler);
                    }
                }

                $(window).on('scroll', scrollHandler);
            }
        }
    }

    function isImageLoaded(stripe) {
        var attr = $(stripe).attr('style');

        if (attr == null) {
            return false;
        }

        if (attr.indexOf("background-image:ur") >= 0) {
            return true;
        }

        return false;
    }

    function isVisible(stripe) {
        var stripeTop = $(stripe).offset().top;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        if (viewportBottom > stripeTop) {
            return true;
        }
        return false;
    }

    function loadImage(stripe, small, medium, large, smallBorder, mediumBorder) {
        var screenWidth = $(window).width();
        var stripeStyles = $(stripe).attr('style');
        if (stripeStyles == null) {
            stripeStyles = '';
        }
        stripeStyles = stripeStyles + "background-image:url('";
        if (screenWidth > mediumBorder) {
            stripeStyles = stripeStyles + large + "');";
        }
        else if (screenWidth > smallBorder) {
            stripeStyles = stripeStyles + medium + "');";
        }
        else {
            stripeStyles = stripeStyles + small + "');";
        }

        $(stripe).attr('style', stripeStyles);
    }

    return function initCustomHighlight(args) {
        return new CustomStripe(args.scope, args.IsInEditing, args.Small, args.Medium, args.Large, args.SmallBorder, args.MediumBorder);
    };
});
